import service from '@/store/services/register-customer-service';

const state = {
    customer: {},
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, customer) => {
        state.customer = customer;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    get({ commit, dispatch }, params) {
        return service.get(params)
            .then((role) => { commit('SET_RESOURCE', role); });
    },
};

const getters = {
    customer: state => state.customer
};

const registerCustomer = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default registerCustomer;